module.exports = __webpack_public_path__ + "static/RERA-letter-a0b3977866173685eaaa42341ad31983.jpg";